// Marathi dictionary entries for the pages owned by this shard:
// DigitalTwin.jsx, FieldOps.jsx, PilgrimSupport.jsx
// Flat English -> Marathi phrase table consumed by src/i18n/useTranslate.js.
const shard3 = {

  // ── Shared / common status & severity vocabulary ──────────────────
  "HIGH": "उच्च",
  "MED": "मध्यम",
  "MEDIUM": "मध्यम",
  "CRITICAL": "गंभीर",
  "MODERATE": "मध्यम",
  "NORMAL": "सामान्य",
  "High": "उच्च",
  "Medium": "मध्यम",
  "Critical": "गंभीर",
  "Moderate": "मध्यम",
  "Normal": "सामान्य",
  "Low": "कमी",
  "Watch": "सतर्कता",
  "Active": "सक्रिय",
  "Pending": "प्रलंबित",
  "Resolved": "निकाली",
  "Escalated": "वाढवलेले",
  "In Progress": "प्रगतीपथावर",
  "Open": "खुले",
  "Ready": "सज्ज",
  "Simulated": "सिम्युलेटेड",
  "Done": "पूर्ण",
  "Zone": "झोन",
  "Police": "पोलीस",
  "Health": "आरोग्य",
  "Medical": "वैद्यकीय",
  "Transport": "वाहतूक",
  "Status": "स्थिती",

  // ── DigitalTwin.jsx ─────────────────────────────────────────────
  "feeds live": "फीड्स सक्रिय",
  "delayed, shown below": "विलंबित, खाली दाखवले आहे",
  "This projection runs on the twin engine —": "हे प्रक्षेपण ट्विन इंजिनवर आधारित आहे —",
  "validated at": "अचूकता",
  "accuracy against 5 past events, below": "मागील 5 घटनांच्या तुलनेत पडताळलेली, खाली पहा",
  "DIGITAL TWIN ENGINE — LIVE": "डिजिटल ट्विन इंजिन — लाइव्ह",
  "Maha Kumbh AI Digital Twin v3.2 · Nashik Simhastha 2027": "महा कुंभ एआय डिजिटल ट्विन v3.2 · नाशिक सिंहस्थ 2027",
  "Real-time crowd simulation · Monte Carlo risk modelling · 8 live sensor feeds · Agent-based crowd behaviour · Weather-adjusted · River-level aware": "रिअल-टाइम गर्दी सिम्युलेशन · मॉन्टे कार्लो जोखीम मॉडेलिंग · 8 लाइव्ह सेन्सर फीड्स · एजंट-आधारित गर्दी वर्तन · हवामान-समायोजित · नदी-पातळी जागरूक",
  "Model Ver": "मॉडेल आवृत्ती",
  "Data Lag": "डेटा विलंब",
  "Accuracy": "अचूकता",
  "Agents": "एजंट्स",
  "Simulation Scenarios": "सिम्युलेशन परिस्थिती",
  "Running": "सुरू",
  "Crowd Est.": "अंदाजित गर्दी",
  "Critical Zones": "गंभीर झोन",
  "Evac Time": "निर्वासन वेळ",
  "Peak Risk": "पीक जोखीम",
  "Detail": "तपशील",
  "Stop": "थांबवा",
  "Run": "सुरू करा",
  "Trigger": "कारण",
  "Inputs": "इनपुट्स",
  "Expected Outcomes": "अपेक्षित परिणाम",
  "Pre-positioning Actions": "पूर्व-तैनाती कृती",

  // Scenario names (simulationScenarios)
  "Shahi Snan — Simhastha Peak": "शाही स्नान — सिंहस्थ शिखर",
  "Godavari Bridge Closure": "गोदावरी पूल बंद",
  "Emergency Mass Evacuation": "आणीबाणी सामूहिक निर्वासन",
  "Godavari Flood — Monsoon Risk": "गोदावरी पूर — पावसाळी जोखीम",

  // Scenario detail: trigger
  "Shahi Snan — Simhastha Peak Crowd Day": "शाही स्नान — सिंहस्थ शिखर गर्दी दिवस",
  "Godavari Bridge sudden closure — structural alert": "गोदावरी पूल अचानक बंद — संरचनात्मक इशारा",
  "Emergency mass evacuation — threat level RED": "आणीबाणी सामूहिक निर्वासन — धोका पातळी लाल",
  "Godavari flood watch — monsoon river surge": "गोदावरी पूर सतर्कता — पावसाळी नदी वाढ",

  // Scenario detail: inputs
  "Weather: Clear, 38°C": "हवामान: स्वच्छ, 38°C",
  "River: Normal": "नदी: सामान्य",
  "All gates open": "सर्व प्रवेशद्वारे खुली",
  "Extra 800 police deployed": "अतिरिक्त 800 पोलीस तैनात",
  "Bridge sensors: Vibration alert": "पूल सेन्सर: कंपन इशारा",
  "1,80,000 pedestrians diverted": "1,80,000 पादचारी वळवले",
  "Alternate: NH3 + Gangapur Road": "पर्यायी मार्ग: NH3 + गंगापूर रोड",
  "Security alert — RED level": "सुरक्षा इशारा — लाल पातळी",
  "All zones: Evacuate": "सर्व क्षेत्रे: निर्वासित करा",
  "All exits open simultaneously": "सर्व निर्गमन एकाच वेळी खुली",
  "River level: 8.2m (flood watch at 9m)": "नदी पातळी: 8.2मी (9मी वर पूर सतर्कता)",
  "Rain: 42mm forecast": "पाऊस: 42मिमी अंदाज",
  "Riverside ghats at risk": "नदीकाठचे घाट धोक्यात",

  // Scenario detail: outcomes
  "Peak 9,00,000 pilgrims at 15:00": "15:00 वाजता कमाल 9,00,000 यात्रेकरू",
  "Ramkund reaches 9.8/m² density": "रामकुंड 9.8/मी² घनतेपर्यंत पोहोचते",
  "5 critical zones simultaneously": "एकाच वेळी 5 गंभीर क्षेत्रे",
  "6,20,000 pilgrims rerouted in 45 min": "45 मिनिटांत 6,20,000 यात्रेकरू वळवले",
  "Panchvati bottleneck hits 8.4/m²": "पंचवटी अडथळा 8.4/मी² पर्यंत पोहोचतो",
  "Transit time +22 min for all zones": "सर्व क्षेत्रांसाठी प्रवास वेळ +22 मिनिटे",
  "6,84,000 pilgrims to be evacuated": "6,84,000 यात्रेकरूंना निर्वासित करावे लागेल",
  "Minimum clearance time: 21 min": "किमान निर्वासन वेळ: 21 मिनिटे",
  "6 exits active concurrently": "6 निर्गमन एकाच वेळी सक्रिय",
  "4,20,000 pilgrims in riverside zones alerted": "नदीकाठच्या क्षेत्रातील 4,20,000 यात्रेकरूंना सतर्क केले",
  "Ramkund Ghat evacuated by T+30": "रामकुंड घाट T+30 पर्यंत रिकामा",
  "Gangapur Camp remains operational": "गंगापूर कॅम्प कार्यरत राहतो",

  // Scenario detail: pre-positioning
  "Deploy SRP Company 3 at Ramkund Entry 2 by 12:00": "12:00 पर्यंत रामकुंड प्रवेश 2 वर SRP कंपनी 3 तैनात करा",
  "Pre-position 3 ambulances at Camp Beta": "कॅम्प बीटा येथे 3 रुग्णवाहिका पूर्व-तैनात करा",
  "Open Camp Delta shelter overflow at 13:30": "13:30 वाजता कॅम्प डेल्टा निवारा ओव्हरफ्लो खुला करा",
  "Immediate police cordon at bridge both ends": "पुलाच्या दोन्ही टोकांना तात्काळ पोलीस घेराव",
  "Deploy 40 buses to Gangapur alternate route": "गंगापूर पर्यायी मार्गावर 40 बस तैनात करा",
  "Broadcast advisory within 5 min of closure": "बंद झाल्यापासून 5 मिनिटांत सूचना प्रसारित करा",
  "All police cordon gates immediately": "सर्व पोलीस त्वरित प्रवेशद्वारे घेरतील",
  "NDRF teams at all 6 exits": "सर्व 6 निर्गमनांवर NDRF पथके",
  "Medical teams at exit points for vulnerable pilgrims": "असुरक्षित यात्रेकरूंसाठी निर्गमन बिंदूंवर वैद्यकीय पथके",
  "Evacuate all riverside ghats by T+30": "T+30 पर्यंत सर्व नदीकाठचे घाट रिकामे करा",
  "Deploy NDRF water rescue teams": "NDRF जल बचाव पथके तैनात करा",
  "Close Godavari bridge to pedestrians pre-emptively": "गोदावरी पूल पादचाऱ्यांसाठी आधीच बंद करा",

  "Idle — select a scenario and press Run": "निष्क्रिय — परिस्थिती निवडा आणि सुरू करा दाबा",
  "Simulation running": "सिम्युलेशन सुरू आहे",
  "Risk Index": "जोखीम निर्देशांक",
  "Evacuated": "निर्वासित",
  "T Elapsed": "गेलेला वेळ",
  "Next Event": "पुढील घटना",
  "Select a scenario above and press": "वरील परिस्थिती निवडा आणि दाबा",
  "to start simulation": "सिम्युलेशन सुरू करण्यासाठी",
  "Crowd Flow": "गर्दी प्रवाह",
  "Density %": "घनता %",

  "START": "सुरुवात",
  "ALERT": "इशारा",
  "ACTION": "कृती",
  "RESOLVED": "निराकरण झाले",

  "Simulation started — Scenario: Shahi Snan Peak": "सिम्युलेशन सुरू — परिस्थिती: शाही स्नान शिखर",
  "Ramkund Entry 2 density exceeds 9/m²": "रामकुंड प्रवेश 2 घनता 9/मी² पेक्षा जास्त",
  "AI triggers crowd diversion — Entry 2 → Entry 4": "AI ने गर्दी वळवली — प्रवेश 2 → प्रवेश 4",
  "Police cordon deployed at Godavari Bridge south": "गोदावरी पुलाच्या दक्षिणेला पोलीस घेराव तैनात",
  "Medical pre-position activated — Camp Alpha": "वैद्यकीय पूर्व-तैनाती सक्रिय — कॅम्प अल्फा",
  "Crowd density begins falling — diversion working": "गर्दी घनता कमी होऊ लागली — वळवणी यशस्वी",
  "Shelter Camp Delta opened — overflow resolved": "निवारा कॅम्प डेल्टा उघडले — ओव्हरफ्लो निराकरण",
  "Risk Index drops below 7.0 — normalized": "जोखीम निर्देशांक 7.0 च्या खाली — सामान्य झाले",

  "Multi-Scenario Comparison": "बहु-परिस्थिती तुलना",
  "Resource Pre-positioning": "संसाधन पूर्व-तैनाती",
  "Live Sensor Feeds": "लाइव्ह सेन्सर फीड्स",
  "Infrastructure Status": "पायाभूत सुविधा स्थिती",

  "Metric": "मापदंड",
  "Shahi Snan Peak": "शाही स्नान शिखर",
  "Bridge Closure": "पूल बंद",
  "Mass Evacuation": "सामूहिक निर्वासन",
  "Flood Scenario": "पूर परिस्थिती",
  "Peak Crowd": "पीक गर्दी",
  "Police Required": "आवश्यक पोलीस",
  "Medical Units": "वैद्यकीय युनिट्स",
  "Peak Risk Index": "कमाल जोखीम निर्देशांक",
  "Buses Needed": "आवश्यक बसेस",
  "SLA Feasibility": "SLA व्यवहार्यता",
  "Feasible": "व्यवहार्य",
  "Stretch": "ताणलेले",

  "Health Teams": "आरोग्य पथके",
  "NDRF": "एनडीआरएफ",
  "Buses": "बसेस",
  "Shelter Slots": "निवारा जागा",
  "Readiness": "सज्जता",

  "Ramkund Ghat": "रामकुंड घाट",
  "Panchvati": "पंचवटी",
  "Trimbakeshwar": "त्र्यंबकेश्वर",
  "Nashik Road Stn": "नाशिक रोड स्थानक",
  "Kalaram Temple": "काळाराम मंदिर",
  "Gangapur Camp": "गंगापूर कॅम्प",

  "Camera": "कॅमेरा",
  "Sensor": "सेन्सर",

  "Ramkund Ghat Entry 2 — CCTV": "रामकुंड घाट प्रवेश 2 — CCTV",
  "Panchvati Ghat — Pressure Sensor": "पंचवटी घाट — दाब सेन्सर",
  "Godavari Bridge — Overhead Camera": "गोदावरी पूल — ओव्हरहेड कॅमेरा",
  "IMD Weather Station — Nashik": "IMD हवामान केंद्र — नाशिक",
  "Godavari River Level — Ramkund": "गोदावरी नदी पातळी — रामकुंड",
  "Police Fleet GPS — Zone Ramkund": "पोलीस ताफा GPS — क्षेत्र रामकुंड",
  "Trimbakeshwar — Entry Gate Camera": "त्र्यंबकेश्वर — प्रवेशद्वार कॅमेरा",
  "Nashik Rd Parking — Sensor Array": "नाशिक रोड पार्किंग — सेन्सर अ‍ॅरे",

  "Last": "शेवटचे",
  "2s ago": "2 सेकंदांपूर्वी",
  "4s ago": "4 सेकंदांपूर्वी",
  "3s ago": "3 सेकंदांपूर्वी",
  "30s ago": "30 सेकंदांपूर्वी",
  "10s ago": "10 सेकंदांपूर्वी",
  "5s ago": "5 सेकंदांपूर्वी",
  "2m ago": "2 मिनिटांपूर्वी",
  "Live": "थेट",
  "Delayed": "विलंबित",

  "Ramkund Ghat Entry Gates (4)": "रामकुंड घाट प्रवेशद्वारे (4)",
  "Godavari Bridge": "गोदावरी पूल",
  "Panchvati Bridge": "पंचवटी पूल",
  "Camp Alpha — Medical": "कॅम्प अल्फा — वैद्यकीय",
  "Camp Beta — Medical": "कॅम्प बीटा — वैद्यकीय",
  "Shelter Camp 3 (NR)": "निवारा कॅम्प 3 (NR)",
  "Shuttle Bay — Nashik Road": "शटल बे — नाशिक रोड",
  "Emergency Generator — Zone A": "आणीबाणी जनरेटर — क्षेत्र अ",

  "Gate": "प्रवेशद्वार",
  "Bridge": "पूल",
  "Shelter": "निवारा",
  "Transit": "मार्गस्थ",
  "Power": "वीज",
  "Operational": "कार्यरत",
  "Near Capacity": "क्षमतेजवळ",
  "94% Full": "94% भरलेले",
  "On Standby": "सज्ज स्थितीत",

  "North Exit — Mumbai-Nashik NH3": "उत्तर निर्गमन — मुंबई-नाशिक NH3",
  "East Exit — Nashik Road Station": "पूर्व निर्गमन — नाशिक रोड स्थानक",
  "South Exit — Gangapur Road": "दक्षिण निर्गमन — गंगापूर रोड",
  "Godavari River Route": "गोदावरी नदी मार्ग",
  "West Exit — Panchvati Road": "पश्चिम निर्गमन — पंचवटी रोड",
  "Emergency Trimbak Corridor": "आणीबाणी त्र्यंबक कॉरिडॉर",
  "Clear": "मोकळे",
  "Restricted": "प्रतिबंधित",
  "m clear": " मि. मोकळे",
  "K cap": " हजार क्षमता",
  "% load": "% भार",
  "lanes": "लेन",
  "Buses + Personal": "बस + खासगी वाहने",
  "Train + Walk": "रेल्वे + पायी",
  "All modes": "सर्व प्रकार",
  "Foot only": "फक्त पायी",
  "Buses + Walk": "बस + पायी",
  "Emergency only": "फक्त आणीबाणी",
  "Load %": "भार %",
  "Clearance (min)": "मोकळे होण्याचा वेळ (मि.)",

  "Environmental Conditions — Simulation Inputs": "पर्यावरणीय परिस्थिती — सिम्युलेशन इनपुट्स",
  "Temperature": "तापमान",
  "Humidity": "आर्द्रता",
  "Wind Speed": "वाऱ्याचा वेग",
  "Rain Forecast": "पावसाचा अंदाज",
  "River Level": "नदी पातळी",
  "UV Index": "अतिनील निर्देशांक",

  "Nashik 2015 — Snan 1": "नाशिक 2015 — स्नान 1",
  "Nashik 2015 — Snan 2": "नाशिक 2015 — स्नान 2",
  "Ujjain 2016": "उज्जैन 2016",
  "Trimbak 2015": "त्र्यंबक 2015",
  "Test Run — Jun 2027": "चाचणी फेरी — जून 2027",
  "Predicted": "अंदाजित",
  "Actual": "प्रत्यक्ष",
  "Error": "त्रुटी",

  "Planning": "नियोजन सुरू",
  "Planned": "नियोजित",
  "days": "दिवस",
  "Shahi Snan 1 — Simhastha Pournima": "शाही स्नान 1 — सिंहस्थ पौर्णिमा",
  "Shahi Snan 2 — Shravani Pournima": "शाही स्नान 2 — श्रावणी पौर्णिमा",
  "Shahi Snan 3 — Bhadrapada": "शाही स्नान 3 — भाद्रपद",
  "Today — Regular Snan": "आज — नियमित स्नान",
  "Expected crowd": "अपेक्षित गर्दी",
  "risk": "जोखीम",

  "Operational Readiness — 6 Dimensions": "कार्यान्वयन सज्जता — 6 आयाम",

  // ── FieldOps.jsx ────────────────────────────────────────────────
  "tasks today — earlier-shift and routine tasks are in the full shift log, not this live board":
    "आजची कामे — मागील शिफ्टमधील आणि नियमित कामे या थेट फलकात नाहीत, ती संपूर्ण शिफ्ट नोंदीत आहेत",
  "Maha Kumbh AI Decision Copilot": "महा कुंभ एआय निर्णय कोपायलट",
  "Generates prioritised SOPs per incident from zone density, historical patterns, resource availability and time-of-day risk. Issues proactive recommendations before incidents escalate. All actions require human officer approval — no autonomous enforcement.":
    "घटनेनुसार क्षेत्र घनता, ऐतिहासिक नमुने, संसाधन उपलब्धता आणि दिवसाच्या वेळेनुसार जोखीम यावर आधारित प्राधान्यक्रमित SOP तयार करते. घटना वाढण्यापूर्वी सक्रिय शिफारसी देते. सर्व कृतींसाठी मानवी अधिकाऱ्याची मान्यता आवश्यक — कोणतीही स्वायत्त अंमलबजावणी नाही.",
  "Active Incident Copilot Feed": "सक्रिय घटना कोपायलट फीड",
  "SOP steps done": "SOP पायऱ्या पूर्ण",
  "SLA": "एसएलए",
  "confidence": "विश्वासार्हता",
  "Collapse": "संकुचित करा",
  "View Full SOP": "संपूर्ण SOP पहा",
  "AI Recommended SOP": "AI शिफारस केलेले SOP",
  "Human Approval Required": "मानवी मान्यता आवश्यक",
  "AI Confidence Breakdown": "AI विश्वासार्हता विभाजन",
  "wt": "भार",
  "Assigned Resources": "नियुक्त संसाधने",
  "Approve & Execute SOP": "SOP मंजूर करा आणि अंमलात आणा",
  "Escalate to Senior": "वरिष्ठांकडे पाठवा",
  "Modify SOP": "SOP सुधारित करा",
  "Radio Officer": "रेडिओ अधिकारी",
  "✓ Done": "✓ पूर्ण",
  "min left": "मि. शिल्लक",
  "Task Management Board": "कार्य व्यवस्थापन फलक",
  "officers": "अधिकारी",
  "gap": "तफावत",
  "coverage": "व्याप्ती",
  "— reinforcement needed": "— मजबुतीकरण आवश्यक",
  "Officer": "अधिकारी",
  "Rank": "पद",
  "Tasks Today": "आजची कामे",
  "Completed": "पूर्ण",
  "SLA Hit %": "SLA पूर्तता %",
  "Incidents": "घटना",
  "Radio": "रेडिओ",
  "Volunteers": "स्वयंसेवक",
  "Ambulance": "रुग्णवाहिका",
  "Fire": "अग्निशमन",
  "Tasks Completed": "पूर्ण झालेली कामे",
  "Incidents Raised": "नोंदवलेल्या घटना",
  "Avg SLA Hit": "सरासरी SLA पूर्तता",
  "Escalates in 5 min": "5 मिनिटांत वाढवले जाते",
  "Escalates in 10 min": "10 मिनिटांत वाढवले जाते",
  "LOW/MED": "कमी/मध्यम",
  "Self-managed": "स्वयं-व्यवस्थापित",
  "AI-generated handover brief · Shift B start time: 16:00 IST · All P1 items require verbal confirmation":
    "AI-निर्मित हस्तांतरण अहवाल · शिफ्ट B सुरू वेळ: 16:00 IST · सर्व P1 बाबींसाठी तोंडी पुष्टी आवश्यक",

  "Assigned": "नियुक्त",
  "Pending Escalation": "प्रलंबित वाढ",
  "Closed Today": "आज बंद झालेले",
  "Officer Performance": "अधिकारी कामगिरी",
  "Resource Deployment": "संसाधन तैनाती",

  "Crowd surge — density > 9/m² at Ramkund": "रामकुंड येथे गर्दी वाढ — घनता > 9/मी²",
  "Water tanker not arrived — Station 8, Panchvati": "पाण्याचा टँकर पोहोचला नाही — स्थानक 8, पंचवटी",
  "Ambulance access blocked — medical emergency": "रुग्णवाहिका प्रवेश अडवला — वैद्यकीय आणीबाणी",
  "Ramkund Ghat, Entry Gate 2, Nashik": "रामकुंड घाट, प्रवेशद्वार 2, नाशिक",
  "Panchvati Zone, Water Point 8, Nashik": "पंचवटी क्षेत्र, पाणी केंद्र 8, नाशिक",
  "Medical Camp Beta, Trimbakeshwar Road": "वैद्यकीय कॅम्प बीटा, त्र्यंबकेश्वर रोड",

  "Deploy 3 additional platoons at Entry 2": "प्रवेश 2 वर अतिरिक्त 3 प्लाटून तैनात करा",
  "Activate crowd diversion via Godavari Route B": "गोदावरी मार्ग B द्वारे गर्दी वळवणी सक्रिय करा",
  "Alert medical standby team at Camp Alpha": "कॅम्प अल्फा येथे वैद्यकीय स्टँडबाय पथकाला सतर्क करा",
  "Close Entry 2 if density exceeds 10/m²": "घनता 10/मी² पेक्षा जास्त झाल्यास प्रवेश 2 बंद करा",
  "Update War Room every 5 min": "दर 5 मिनिटांनी वॉर रूमला अद्ययावत करा",
  "Contact tanker contractor immediately": "त्वरित टँकर कंत्राटदाराशी संपर्क साधा",
  "Redirect nearest NMC tanker (T-14, ETA 12 min)": "जवळचा NMC टँकर वळवा (T-14, ETA 12 मि.)",
  "Inform pilgrims via PA system": "PA प्रणालीद्वारे यात्रेकरूंना माहिती द्या",
  "Log breach in audit trail": "उल्लंघन ऑडिट नोंदीत नोंदवा",
  "Request police escort immediately": "त्वरित पोलीस एस्कॉर्टची विनंती करा",
  "Clear Trimbak Road obstruction via Zone B officer": "क्षेत्र B अधिकाऱ्यामार्फत त्र्यंबक रोड अडथळा दूर करा",
  "Stabilise patient at Camp Beta until ambulance arrives": "रुग्णवाहिका येईपर्यंत कॅम्प बीटा येथे रुग्णाला स्थिर करा",
  "Escalate to DCP if not cleared in 5 min": "5 मिनिटांत निराकरण न झाल्यास DCP कडे वाढवा",

  "Zone Density Score": "क्षेत्र घनता गुण",
  "Historical Pattern": "ऐतिहासिक नमुना",
  "Time-of-Day Risk": "दिवसाच्या वेळेनुसार जोखीम",
  "Weather Adjustment": "हवामान समायोजन",
  "Resource Availability": "संसाधन उपलब्धता",
  "Service Stress Level": "सेवा ताण पातळी",
  "Logistics Data": "लॉजिस्टिक्स डेटा",
  "Medical Urgency Score": "वैद्यकीय निकड गुण",
  "Route Blockage AI": "मार्ग अडथळा AI",
  "Resource Proximity": "संसाधन जवळीक",

  "2× SRP Platoon deployed": "2× SRP प्लाटून तैनात",
  "Police Van PV-08": "पोलीस व्हॅन PV-08",
  "Crowd Diversion Barrier Set B": "गर्दी वळवणी बॅरियर संच B",
  "Medical Standby — AM-01": "वैद्यकीय स्टँडबाय — AM-01",
  "NMC Tanker TK-12 (in transit)": "NMC टँकर TK-12 (मार्गावर)",
  "PA System PA-07": "PA प्रणाली PA-07",
  "Water Station Monitor": "पाणी केंद्र निरीक्षण",
  "Ambulance AM-03 (blocked)": "रुग्णवाहिका AM-03 (अडवलेली)",
  "Police Escort PQ-01 (requested)": "पोलीस एस्कॉर्ट PQ-01 (विनंती केलेली)",
  "NDRF Unit 2 (standby)": "NDRF युनिट 2 (स्टँडबाय)",

  "Crowd surge Ramkund Entry 2": "गर्दी वाढ रामकुंड प्रवेश 2",
  "Ambulance access blocked — Camp B": "रुग्णवाहिका प्रवेश अडवला — कॅम्प B",
  "Water tanker missing — Panchvati": "पाण्याचा टँकर गहाळ — पंचवटी",
  "Shelter overload — Camp 3": "निवारा ओव्हरलोड — कॅम्प 3",
  "Missing child — Panchvati Sec 7": "हरवलेले मूल — पंचवटी विभाग 7",
  "Heatstroke cluster — Zone D": "उष्माघात समूह — झोन D",
  "Monitoring": "निरीक्षणाधीन",

  "Proactive": "सक्रिय-पूर्व",
  "Reactive": "प्रतिक्रियात्मक",
  "Advisory": "सल्लागार",
  "Ramkund": "रामकुंड",
  "Trimbak": "त्र्यंबक",
  "Nashik Rd": "नाशिक रोड",
  "All Zones": "सर्व झोन",
  "Gangapur": "गंगापूर",
  "Density reaching 9.2/m² — recommend pre-positioning 2 platoons at Entry 4 before 15:00 peak": "घनता 9.2/मी² पर्यंत पोहोचत आहे — 15:00 च्या शिखरापूर्वी प्रवेश 4 वर 2 प्लाटून पूर्व-तैनात करण्याची शिफारस",
  "Water demand will spike at Ghat Steps in 18 min — dispatch NMC tanker TK-14 now for zero-gap supply": "18 मिनिटांत घाट पायऱ्यांवर पाण्याची मागणी वाढेल — तफावतरहित पुरवठ्यासाठी आता NMC टँकर TK-14 पाठवा",
  "Ambulance AM-03 route blocked — alternate route via NH3 link road saves 8 min clearance time": "रुग्णवाहिका AM-03 चा मार्ग अडवला — NH3 लिंक रोडमार्गे पर्यायी मार्गाने 8 मिनिटे वाचतात",
  "Train 12166 arriving 14:42 — expected 3,200 pilgrims. Alert Nashik Road beat squad to Gate 3": "रेल्वे 12166 14:42 वाजता येत आहे — अंदाजे 3,200 यात्रेकरू. नाशिक रोड बीट पथकाला गेट 3 कडे सतर्क करा",
  "UV Index 9 and temperature 38°C — ORS distribution should be increased by 40% in Ramkund zone": "UV निर्देशांक 9 आणि तापमान 38°C — रामकुंड क्षेत्रात ORS वितरण 40% वाढवावे",
  "Shelter utilisation at 44% — redirect overflow from Camp 3 to Gangapur Camp D (500 slots free)": "निवारा वापर 44% — कॅम्प 3 मधील ओव्हरफ्लो गंगापूर कॅम्प D कडे वळवा (500 जागा रिकाम्या)",
  "Pre-position now": "आता पूर्व-तैनात करा",
  "Dispatch tanker": "टँकर पाठवा",
  "Reroute AM-03": "AM-03 पुनर्मार्गित करा",
  "Alert beat squad": "बीट पथकाला सतर्क करा",
  "Increase ORS": "ORS वाढवा",
  "Open Camp D": "कॅम्प D उघडा",

  "Deploy barricade — Ramkund Entry 2 west side": "बॅरिकेड तैनात करा — रामकुंड प्रवेश 2 पश्चिम बाजू",
  "Confirm ORS stock at Panchvati Ghat Steps": "पंचवटी घाट पायऱ्यांवर ORS साठा तपासा",
  "Pre-position ambulance AM-04 at Camp Beta": "कॅम्प बीटा येथे रुग्णवाहिका AM-04 पूर्व-तैनात करा",
  "Crowd diversion — Gate 2 → Gate 4 active": "गर्दी वळवणी — गेट 2 → गेट 4 सक्रिय",
  "Missing child search — MP-1185, Panchvati Sec 7": "हरवलेले मूल शोध — MP-1185, पंचवटी विभाग 7",
  "Water tanker reroute — TK-12 to Station 8": "पाण्याचा टँकर पुनर्मार्गित — TK-12 ते स्थानक 8",
  "Ambulance route clearance — Trimbak Rd": "रुग्णवाहिका मार्ग मोकळा — त्र्यंबक रोड",
  "Shelter Camp Delta activation — Revenue Dept": "निवारा कॅम्प डेल्टा सक्रियकरण — महसूल विभाग",
  "Heatstroke cluster Zone D — all 6 stabilised": "उष्माघात समूह क्षेत्र D — सर्व 6 स्थिर",
  "Missing person MP-1182 reunited with family": "हरवलेली व्यक्ती MP-1182 कुटुंबाशी पुनर्मिलन",
  "Bridge congestion cleared — Police escort done": "पूल गर्दी दूर — पोलीस एस्कॉर्ट पूर्ण",
  "Revenue": "महसूल",

  "AI Copilot": "AI कोपायलट",
  "Command Centre": "कमांड सेंटर",
  "Radio CH-4": "रेडिओ CH-4",
  "App Alert": "अ‍ॅप सूचना",
  "Radio CH-2": "रेडिओ CH-2",
  "Broadcast": "प्रसारण",
  "App": "अॅप",
  "Alert": "इशारा",
  "Radio CH-3": "रेडिओ CH-3",
  "Diversion active at Entry 2. Requesting 1 more platoon from reserve.": "प्रवेश 2 वर वळवणी सक्रिय. राखीव दलातून आणखी 1 प्लाटूनची विनंती.",
  "Recommend closing Entry 2 if density exceeds 9.5/m² in next 5 min.": "पुढील 5 मिनिटांत घनता 9.5/मी² पेक्षा जास्त झाल्यास प्रवेश 2 बंद करण्याची शिफारस.",
  "Ambulance AM-03 still blocked — need immediate police escort on Trimbak Road.": "रुग्णवाहिका AM-03 अजूनही अडवलेली — त्र्यंबक रोडवर त्वरित पोलीस एस्कॉर्ट आवश्यक.",
  "All officers — peak crowd window 15:00–16:00. Maximum vigilance required.": "सर्व अधिकारी — कमाल गर्दी वेळ 15:00–16:00. जास्तीत जास्त सतर्कता आवश्यक.",
  "Replacement tanker TK-12 dispatched. ETA Panchvati 15:12.": "बदली टँकर TK-12 पाठवला. पंचवटी येथे पोहोचण्याची वेळ 15:12.",
  "Missing child MP-1185 — 3 possible matches in CCTV feed Sector 6 & 7.": "हरवलेले मूल MP-1185 — CCTV फीड विभाग 6 आणि 7 मध्ये 3 संभाव्य जुळणी.",
  "MP-1185 search underway — checking Sector 6 footage now.": "MP-1185 शोध सुरू — आता विभाग 6 चे फुटेज तपासत आहे.",
  "Heatstroke risk rising Zone D — recommend ORS deployment before 14:30.": "उष्माघात धोका वाढतोय क्षेत्र D — 14:30 पूर्वी ORS वितरणाची शिफारस.",

  "Inspector": "निरीक्षक",
  "Constable": "शिपाई",
  "CMO Health": "CMO आरोग्य",
  "JE Municipal": "JE महानगरपालिका",
  "Head Const.": "मुख्य शिपाई",
  "Sub-Insp.": "उप-निरीक्षक",
  "Trimbak Rd Camp": "त्र्यंबक रोड कॅम्प",
  "Panchvati Zone": "पंचवटी झोन",
  "Responding": "प्रतिसाद देत आहे",
  "On Duty": "कर्तव्यावर",
  "Emergency": "आणीबाणी",

  "Field Officer": "क्षेत्रीय अधिकारी",
  "Inspector / PSI": "निरीक्षक / PSI",
  "DCP / CMO / Collector": "DCP / CMO / जिल्हाधिकारी",
  "SP / District Collector": "SP / जिल्हाधिकारी",
  "CM Office / CS": "मुख्यमंत्री कार्यालय / मुख्य सचिव",
  "T+0 — First response": "T+0 — प्रथम प्रतिसाद",
  "T+5 min — if unresolved": "T+5 मि. — निराकरण न झाल्यास",
  "T+10 min — HIGH priority": "T+10 मि. — उच्च प्राधान्य",
  "T+15 min — CRITICAL only": "T+15 मि. — फक्त गंभीर",
  "T+20 min — State-level threat": "T+20 मि. — राज्यस्तरीय धोका",

  "In Transit": "मार्गावर",
  "INC-8821 — Crowd surge Ramkund Entry 2": "INC-8821 — गर्दी वाढ रामकुंड प्रवेश 2",
  "INC-8819 — Ambulance block Camp Beta": "INC-8819 — रुग्णवाहिका अडथळा कॅम्प बीटा",
  "MP-1185 — Missing child Panchvati Sec 7": "MP-1185 — हरवलेले मूल पंचवटी विभाग 7",
  "Camp 3 Shelter overflow → Camp Delta": "कॅम्प 3 निवारा ओव्हरफ्लो → कॅम्प डेल्टा",
  "Water tanker TK-12 — ETA 15:12 Station 8": "पाण्याचा टँकर TK-12 — पोहोचण्याची वेळ 15:12 स्थानक 8",
  "Diversion active — monitor Entry 4 flow": "वळवणी सक्रिय — प्रवेश 4 प्रवाहावर लक्ष ठेवा",
  "Police escort requested — DCP approved": "पोलीस एस्कॉर्टची विनंती — DCP मंजूर",
  "CCTV search in progress Sectors 6–8": "CCTV शोध सुरू विभाग 6–8",
  "Delta activation ETA 16:00": "डेल्टा सक्रियकरण अंदाजे वेळ 16:00",
  "Monitor arrival and log confirmation": "आगमनावर लक्ष ठेवा आणि पुष्टी नोंदवा",

  // ── PilgrimSupport.jsx ──────────────────────────────────────────
  "ALL CHANNELS OPERATIONAL": "सर्व वाहिन्या कार्यरत",
  "Maha Kumbh AI Pilgrim Guidance Engine — Simhastha 2027": "महा कुंभ एआय यात्रेकरू मार्गदर्शन इंजिन — सिंहस्थ 2027",
  "Marathi-first multilingual AI · WhatsApp · SMS · IVR · Help Desk · 43,180 queries handled today · 72% AI auto-resolved · 4 channels live":
    "मराठी-प्रथम बहुभाषिक AI · WhatsApp · SMS · IVR · मदत केंद्र · आज 43,180 प्रश्न हाताळले · 72% AI द्वारे स्वयं-निराकरण · 4 वाहिन्या सक्रिय",
  "up": "कार्यरत",
  "In Queue": "रांगेत",
  "Avg Wait": "सरासरी प्रतीक्षा",
  "satisfaction": "समाधान",
  "Satisfaction": "समाधान",
  "SMS": "SMS",
  "HelpDesk": "मदत केंद्र",
  "Marathi-First Multilingual AI Guidance Engine": "मराठी-प्रथम बहुभाषिक AI मार्गदर्शन इंजिन",
  "Maha Kumbh AI operates Marathi as primary (42%). AI NLP translates in real-time across 5 languages. Feature-phone pilgrims receive Unicode SMS in local script. IVR offers regional dialect support. No internet required for SMS or IVR channels — full digital-divide coverage.":
    "महा कुंभ एआय मराठीला प्रमुख भाषा (42%) म्हणून वापरते. AI NLP 5 भाषांमध्ये रिअल-टाइम भाषांतर करते. फीचर-फोन यात्रेकरूंना स्थानिक लिपीत युनिकोड SMS मिळतो. IVR प्रादेशिक बोलीभाषेचा आधार देते. SMS किंवा IVR वाहिन्यांसाठी इंटरनेटची आवश्यकता नाही — संपूर्ण डिजिटल-दरी व्याप्ती.",
  "queries": "प्रश्न",
  "human corrections": "मानवी सुधारणा",
  "WhatsApp avg": "WhatsApp सरासरी",
  "SMS avg": "SMS सरासरी",
  "IVR avg": "IVR सरासरी",
  "Zone-wise Pilgrim Advisory Board": "क्षेत्रनिहाय यात्रेकरू सल्ला फलक",
  "Live Broadcasts & Advisories": "लाइव्ह प्रसारण आणि सूचना",
  "reach": "पोहोच",
  "opened": "उघडले",
  "Total Cases": "एकूण प्रकरणे",
  "Missing Person Helpline: 1800-266-0400 · Camp B Gate 6 · WhatsApp: +91-8888-266-400":
    "हरवलेली व्यक्ती हेल्पलाइन: 1800-266-0400 · कॅम्प B गेट 6 · WhatsApp: +91-8888-266-400",
  "done": "पूर्ण",
  "Total IVR Calls": "एकूण IVR कॉल्स",
  "Completion Rate": "पूर्णता दर",
  "Avg Call Duration": "सरासरी कॉल कालावधी",

  "SMS / Text": "SMS / मजकूर",
  "IVR / Voice": "IVR / आवाज",
  "Help Desk": "मदत केंद्र",

  "AI Auto-resolved": "AI स्वयं-निराकरण",
  "Human Assisted": "मानवी सहाय्यित",

  "Marathi": "मराठी",
  "Hindi": "हिंदी",
  "English": "इंग्रजी",
  "Gujarati": "गुजराती",
  "Others": "इतर",
  "Route Guidance": "मार्ग मार्गदर्शन",
  "Lost Person": "हरवलेली व्यक्ती",
  "Medical Help": "वैद्यकीय मदत",
  "Transport Info": "वाहतूक माहिती",
  "Shelter/Food": "निवारा/अन्न",
  "General Info": "सामान्य माहिती",

  "मराठी (Marathi)": "मराठी",
  "हिंदी (Hindi)": "हिंदी",
  "ગુજરાતી (Gujarati)": "ગુજરાતી (गुजराती)",
  "Other Regional": "इतर प्रादेशिक",

  "Answered": "उत्तर दिले",
  "My elderly mother needs wheelchair — help?": "माझ्या वृद्ध आईला व्हीलचेअर हवी आहे — मदत करा?",
  "~25 min walk via Bridge Road": "ब्रिज रोडमार्गे ~25 मिनिटे पायी",
  "P2 zone — Nashik Road Station, 800m": "P2 क्षेत्र — नाशिक रोड स्थानक, 800मी",
  "Helpline: 1800-266-0400 or Camp B": "हेल्पलाइन: 1800-266-0400 किंवा कॅम्प B",
  "Bus Bay 9 — SR-07 departs at 15:10": "बस बे 9 — SR-07 15:10 वाजता सुटते",
  "Escorted to wheelchair service desk": "व्हीलचेअर सेवा डेस्ककडे नेले",
  "Food Zone A — Gate 3 entry, 150m": "अन्न क्षेत्र A — गेट 3 प्रवेश, 150मी",
  "Water Point W-04 — 300m north Gate 2": "पाणी केंद्र W-04 — गेट 2 च्या 300मी उत्तरेस",
  "Gate 4 via Godavari Bridge — 800m": "गेट 4 गोदावरी पुलामार्गे — 800मी",

  "9.2/m² — overcrowded": "9.2/मी² — अतिगर्दी",
  "8.1/m² — busy": "8.1/मी² — व्यस्त",
  "7.6/m² — manageable": "7.6/मी² — नियंत्रणीय",
  "6.8/m² — normal": "6.8/मी² — सामान्य",
  "5.8/m² — comfortable": "5.8/मी² — आरामदायक",
  "4.1/m² — relaxed": "4.1/मी² — निवांत",

  "Route": "मार्ग",
  "Water": "पाणी",
  "Darshan": "दर्शन",
  "Crowd": "गर्दी",

  "Use Gate 4. Avoid Gate 2. Bridge Road alternate.": "गेट 4 वापरा. गेट 2 टाळा. ब्रिज रोड पर्यायी.",
  "Camp Alpha nearby — 200m Gate 4": "कॅम्प अल्फा जवळ — गेट 4 पासून 200मी",
  "No parking — use Park & Ride at NH3": "पार्किंग नाही — NH3 वर पार्क अँड राइड वापरा",
  "W-01, W-02 near Gate 3 (ORS available)": "W-01, W-02 गेट 3 जवळ (ORS उपलब्ध)",
  "Wait: 90 min · Enter via Gate 4 only": "प्रतीक्षा: 90 मि. · फक्त गेट 4 मार्गे प्रवेश",

  "Enter from South Bridge. Avoid Ghat Steps 11:00–15:00.": "दक्षिण पुलावरून प्रवेश करा. घाट पायऱ्या 11:00–15:00 दरम्यान टाळा.",
  "Camp Beta — Gate 6 · Free ORS available": "कॅम्प बीटा — गेट 6 · मोफत ORS उपलब्ध",
  "Shuttle SP-02 every 15 min · Bay 4": "शटल SP-02 दर 15 मि. · बे 4",
  "W-05 to W-09 near Ghat Steps": "W-05 ते W-09 घाट पायऱ्यांजवळ",
  "Accessible · Wait: 30 min": "प्रवेशयोग्य · प्रतीक्षा: 30 मि.",

  "NH3 → Trimbak Road. Free parking available.": "NH3 → त्र्यंबक रोड. मोफत पार्किंग उपलब्ध.",
  "Camp Gamma — Near Main Temple gate": "कॅम्प गॅमा — मुख्य मंदिर प्रवेशद्वाराजवळ",
  "Bus TR-04, TR-05 from Nashik every 30 min": "नाशिकहून दर 30 मि. बस TR-04, TR-05",
  "W-12 at Temple entry · Drinking water free": "W-12 मंदिर प्रवेशद्वारावर · पिण्याचे पाणी मोफत",
  "05:00–23:00 · Wait: 45 min": "05:00–23:00 · प्रतीक्षा: 45 मि.",

  "Station exit → Auto/Bus to Ramkund (3 km)": "स्थानक निर्गमन → रामकुंडसाठी ऑटो/बस (3 किमी)",
  "Camp Delta — Station forecourt": "कॅम्प डेल्टा — स्थानक प्रांगण",
  "Trains on time · Next 14:42 Platf. 2": "गाड्या वेळेवर · पुढील 14:42 फलाट 2",
  "W-20 at Station forecourt": "W-20 स्थानक प्रांगणात",
  "Buses available to all ghats every 10 min": "सर्व घाटांसाठी दर 10 मि. बस उपलब्ध",

  "Via Panchvati Road · Easy walk from Godavari Ghat": "पंचवटी रोडमार्गे · गोदावरी घाटापासून सोपे चालणे",
  "Camp Epsilon — Temple west side": "कॅम्प एप्सिलॉन — मंदिराची पश्चिम बाजू",
  "Parking available P-4": "पार्किंग उपलब्ध P-4",
  "W-18 near Temple east gate": "W-18 मंदिराच्या पूर्व गेटजवळ",
  "Open · Wait: 15 min": "खुले · प्रतीक्षा: 15 मि.",

  "NH3 → Gangapur Road · Ample space": "NH3 → गंगापूर रोड · भरपूर जागा",
  "Camp Zeta — Fully operational": "कॅम्प झेटा — पूर्णपणे कार्यरत",
  "Free shuttle from Nashik Road": "नाशिक रोडहून मोफत शटल",
  "Ample supply · W-22 to W-26": "भरपूर पुरवठा · W-22 ते W-26",
  "N/A — Shelter zone": "लागू नाही — निवारा क्षेत्र",

  "Nashik Road Station": "नाशिक रोड स्थानक",
  "Gadkari Chowk": "गडकरी चौक",
  "Any Zone": "कोणतेही क्षेत्र",
  "Panchvati Ghat": "पंचवटी घाट",
  "Help & Lost+Found": "मदत आणि हरवले-सापडले",

  "Take Gate 4 — Gate 2 is closed": "गेट 4 वापरा — गेट 2 बंद आहे",
  "Enter from South Bridge — less crowd": "दक्षिण पुलावरून प्रवेश करा — कमी गर्दी",
  "Book early — limited auto after 14:00": "आधी बुक करा — 14:00 नंतर मर्यादित ऑटो",
  "Accessible path — good for elderly": "प्रवेशयोग्य मार्ग — वृद्धांसाठी योग्य",
  "Call 1800-266-0400 · Camp B Panchvati · Gate 6": "कॉल करा 1800-266-0400 · कॅम्प B पंचवटी · गेट 6",

  "Safety": "सुरक्षा",
  "Missing": "हरवलेले",
  "मराठी/Hindi": "मराठी/हिंदी",
  "Hindi/मराठी": "हिंदी/मराठी",
  "All": "सर्व",
  "All channels": "सर्व वाहिन्या",

  "Unknown Child ~7yrs": "अज्ञात मूल ~7 वर्षे",
  "Disabled Female ~52yrs": "दिव्यांग महिला ~52 वर्षे",
  "Panchvati Sector 7": "पंचवटी सेक्टर 7",
  "Kalaram Gate 3": "काळाराम गेट 3",

  "1 — Route Guidance": "1 — मार्ग मार्गदर्शन",
  "2 — Medical Assistance": "2 — वैद्यकीय सहाय्य",
  "3 — Transport / Buses": "3 — वाहतूक / बसेस",
  "4 — Missing Person Report": "4 — हरवलेली व्यक्ती अहवाल",
  "5 — Shelter / Food": "5 — निवारा / अन्न",
  "0 — Human Agent": "0 — मानवी प्रतिनिधी",

  "Smartphone — WhatsApp/App": "स्मार्टफोन — WhatsApp/अ‍ॅप",
  "Feature Phone — SMS only": "फीचर फोन — फक्त SMS",
  "Basic Phone — IVR/Voice": "बेसिक फोन — IVR/आवाज",
  "Walk-in Help Desk": "प्रत्यक्ष मदत केंद्र",

  "मराठी — Primary (42%)": "मराठी — प्रमुख (42%)",
  "Hindi (32%)": "हिंदी (32%)",
  "English (12%)": "इंग्रजी (12%)",
  "Regional (5%)": "प्रादेशिक (5%)",
  "Languages": "भाषा",
  "Dialects": "बोलीभाषा",
  "AI Accuracy": "AI अचूकता",
  "No-Internet": "इंटरनेटविना",

};

export default shard3;
